module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/2GPkaZ/tc-custom/9781937384470.jpg?1708804233287",
      "alt": "This image is the cover for the book Died in the Wool, Roderick Alleyn"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Died in the Wool, Roderick Alleyn\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The inspector digs into a cold case on a New Zealand sheep farm in this “well-sustained crime story” from the Mystery Writers of America Grand Master ("), _c('i', [_vm._v("Kirkus Reviews")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v("Flossie Rubrick, a highly opinionated and influential member of the New Zealand Parliament, was last seen heading off to one of the storage sheds on her sheep farm. Three weeks later, she turned up dead and packed in a bale of her own wool. What happened on the night of her long-ago disappearance? In the country on counterespionage duty, Inspector Roderick Alleyn is happy to lend a hand."), _c('br'), _c('br'), _vm._v("“The doyenne of traditional mystery writers.” —"), _c('i', [_vm._v("The New York Times")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ngaio Marsh\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Felony & Mayhem Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0